export const environment = {
  production: false,
  baseURL: 'https://pre-api.naaora.com', // This represents the base URL for running our frontend project.
  URL: 'http://localhost:4200/assets/data', // Change only the domain part, keeping "/api" intact
  storageURL: 'http://localhost:4200/assets', // Change only the laravel primary domain
  PRODUCTS: '/store/client/v2/products', // PLP resuelta por idioma (Accept-Language); misma forma que v1
  PRODUCT: '/store/client/product/v3',
  SHOPPING_CART: '/store/client/shopping-cart',
  CHECKOUT: '/store/client/checkout',
  SITE_SETTING: '/store/client/site/settings/v2',
  MASTER_COUNTRY: '/master/v2/address/countries',
  CONTACT_US_SEND: '/store/client/site/contact-us/message',
  SITE_CONFIG: '/store/client/template/config',
  NEWSLETTER_UNSUBSCRIBE: '/store/client/newsletter/unsubscribe',
  SITE_CONFIG_SSE: '/store/client/template',
  TEMPLATE_BASE_ID: '0d74dcefd4d04d4f9f3bb279e3571111',
  firebaseConfig: {
    apiKey: "AIzaSyDyW3AEbYhKRBob0YjoT2_SX74hbKUqrAU",
    authDomain: "naaora-dev.firebaseapp.com",
    projectId: "naaora-dev",
    storageBucket: "naaora-dev.firebasestorage.app",
    messagingSenderId: "987286535208",
    appId: "1:987286535208:web:5de9ded473501e9550091d",
    measurementId: "G-28C3GJTWND"
  }
};

